function initialize() {
    document.querySelectorAll('.faq').forEach(function (faq) {
        const more = faq.querySelector('.faq-more');
        const wrap = faq.querySelector('.faq-load-more-wrap');
        const button = faq.querySelector('.faq-load-more');

        if (!more || !wrap || !button) {
            return;
        }

        button.addEventListener('click', function () {
            more.style.height = more.scrollHeight + 'px';
            wrap.style.display = 'none';

            more.addEventListener('transitionend', function handler() {
                more.style.height = 'auto';
                more.removeEventListener('transitionend', handler);
            });
        });
    });
}

initialize();
